import { IOrganizacao } from "../../../Interfaces/Organizacao/Organizacao";
import Axios from "../../Config/API";
import Service from "../../Service";

export async function getInfoOrganizacaoService() {
    return Service(
        Axios.get<IOrganizacao>(`home/organizacao/getorganizacaoinfo`)
    );
}

export async function EditarInformacaoService(organizacao: IOrganizacao) {
    return Service(
        Axios.put(`home/organizacao/atualizaorganizacao`, organizacao)
    );
}
